import React from 'react';
import { Item } from 'semantic-ui-react';

import parseServerChangeLog from './parseServerLog';

const DocumentAction = ({ action, details }) => {
  const { documentId, documentUrl } = parseServerChangeLog(details);
  return documentId ? (
    <Item>
      <Item.Image
        style={{ cursor: 'pointer' }}
        size="tiny"
        src={documentUrl}
      />
      <Item.Content>
        <Item.Meta>
          {action} document id: {documentId}
        </Item.Meta>
      </Item.Content>
    </Item>
  ) : (
    details
  );
};

export default DocumentAction;



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimHistory/HistoryItem/ActionTypes/DocumentAction.js